module.exports = __webpack_public_path__ + "static/img/5149_phase_function_Paper_PointsHejduk_Prediction.6b456ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5149_phase_function_Paper_PointsHejduk_Prediction.png
// module id = h31o
// module chunks = 0